import { Component, ChangeDetectionStrategy } from "@angular/core";
import { ButtonBaseComponent } from "app/shared/components/buttons/button-base.component";

@Component({
  ...ButtonBaseComponent.metaData,
  selector: "app-button-outline-primary",
  templateUrl: "./button-outline-primary.component.html",
  styleUrls: ["./button-outline-primary.component.scss"],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false
})
export class ButtonOutlinePrimaryComponent extends ButtonBaseComponent {}
